import { getNativeCurrency, isNativeCurrencySymbol, nativeCurrencyId } from '@/config/native'
import { isAddress } from '@/utils'
import type { ChainId } from '@/sdk'
import { Currency, Token } from '@/sdk'

export function currencyFromLegId(legId: string, chainId: ChainId): Currency | undefined {
  const native = getNativeCurrency(chainId)
  const nativeId = nativeCurrencyId(chainId)
  if (legId === nativeId || isNativeCurrencySymbol(legId, chainId)) return native
  const addr = isAddress(legId)
  if (addr) return new Token(chainId, addr, 18)
  return undefined
}
